import SUARTE_WORDMARK_DATA_URL from './suarteWordmarkDataUrl';

export default function SuarteName({ className="", onClick=null }) {
  return (
    <>
      <svg className={className} onClick={onClick} viewBox="0 0 82 21" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Suarte Logo">
        <rect width="82" height="21" fill="url(#pattern0)"/>
        <defs>
          <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
            <use xlinkHref="#image0_3_6702" transform="matrix(0.00127412 0 0 0.00497512 -0.0160175 0)"/>
          </pattern>
          <image id="image0_3_6702" width="810" height="201" xlinkHref={SUARTE_WORDMARK_DATA_URL}/>
        </defs>
      </svg>

    </>
  );
}
